import React, { useState } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || 'https://service9003.szapfs.org';

const OrderDetailModal = ({ unit, isOpen, onClose, onOpenUploadModal, onRefresh }) => {
    const [isPrinted, setIsPrinted] = useState(unit?.Printed || false);
    const [isMarking, setIsMarking] = useState(false);

    if (!isOpen || !unit) return null;

    const handlePrintToggle = async () => {
        setIsMarking(true);
        try {
            const newValue = !isPrinted;
            const res = await fetch(`https://service9004.szapfs.org/api/kitunits/${unit.KitUnitID}/print-mark`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ printed: newValue }),
            });
            if (res.ok) {
                setIsPrinted(newValue);
                if (onRefresh) onRefresh();
            }
        } catch (e) {
            console.error('Failed to mark print status:', e);
        } finally {
            setIsMarking(false);
        }
    };

    const actionOptions = [
        { key: 'printed', label: 'Mark as Printed', icon: 'fas fa-print', enabled: true },
        { key: 'notify', label: 'Send Notification', icon: 'fas fa-envelope', enabled: false },
        { key: 'history', label: 'View Full History', icon: 'fas fa-clipboard', enabled: false },
        { key: 'issue', label: 'Report Issue', icon: 'fas fa-exclamation-triangle', enabled: false },
    ];

    const formatDate = (dateString) => {
        if (!dateString) return ' ';
        return new Date(dateString).toLocaleString();
    };

    const getStatusColor = (status) => {
        switch (status?.toLowerCase()) {

            default: return '#6c757d';
        }
    };

    const printSingleLabel = () => {
        // Clean up any previous iframe
        const oldIframe = document.getElementById('print-iframe-single-label');
        if (oldIframe) {
            oldIframe.remove();
        }

        // Create an invisible iframe
        const iframe = document.createElement('iframe');
        iframe.id = 'print-iframe-single-label';
        iframe.style.display = 'none';
        document.body.appendChild(iframe);

        // Write the content to be printed into the iframe
        iframe.contentDocument.write(`
            <html>
                <head>
                    <title>Print Kit Label</title>
                    <style>
                        body { font-family: sans-serif; }
                        .label { border: 1px solid #ccc; padding: 20px; text-align: center; max-width: 300px; margin: 20px auto; }
                        .activation-id { font-weight: bold; font-size: 1.2em; }
                        @media print {
                            body { margin: 0.5in; }
                        }
                    </style>
                </head>
                <body>
                    <div class="label">
                        <div>Kit Unit ID:</div>
                        <div class="activation-id">${unit.ActivationID || unit.KitUnitID.slice(-8)}</div>
                    </div>
                </body>
            </html>
        `);
        iframe.contentDocument.close();

        // Set up cleanup to run after printing is done
        iframe.contentWindow.onafterprint = () => {
            iframe.remove();
        };

        // Focus and print
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
    };

    // Timeline stages in order
    const timelineStages = [
        { key: 'CreationDate', label: 'Created', icon: 'fas fa-plus-circle' },
        { key: 'ActivationDate', label: 'Activated', icon: 'fas fa-play-circle' },
        { key: 'Lab_Received', label: 'Lab Received', icon: 'fas fa-flask' },
                { key: 'Clinician_Validated', label: 'Clinician Validated', icon: 'fas fa-user-md' }

    ];

    return (
        <div className="GORDU-modal-overlay" onClick={onClose}>
            <div className="GORDU-modal-content" onClick={(e) => e.stopPropagation()}>
                <div className="GORDU-modal-header">
                    <h2>Order Details</h2>
                    <button className="GORDU-modal-close" onClick={onClose}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>
                
                <div className="GORDU-modal-body">
                    {/* Activation ID Section - Top */}
                    <div className="GORDU-detail-section GORDU-activation-section">
                        <div className="GORDU-activation-id">
                            <span>{unit.ActivationID}</span>
                            <i className="fas fa-print" onClick={printSingleLabel} style={{ cursor: 'pointer' }}></i>
                        </div>
                    </div>

                    {/* Main Content - Left and Right Layout */}
                    <div className="GORDU-modal-main-content">
                        {/* Left Side - Kit Unit Information and Actions */}
                        <div className="GORDU-modal-left-panel">
                            {/* Kit Unit Information */}
                            <div className="GORDU-detail-section">
                                <h3>Kit Unit Information</h3>
                                <div className="GORDU-detail-grid">
                              
                                    {/* MODIFIED SECTION HERE */}
                                    <div className="GORDU-detail-item GORDU-user-info-item">
                                        {unit.userDetails ? (
                                            <>
                                                <span className="GORDU-detail-label">Activated By:</span>
                                                <div className="GORDU-user-info-card">
                                                    <div className="GORDU-user-avatar">
                                                        {unit.userDetails.firstName?.charAt(0)}{unit.userDetails.lastName?.charAt(0)}
                                                    </div>
                                                    <div className="GORDU-user-details">
                                                        <div className="GORDU-user-name" style={{ display: 'flex', fontSize: '12px', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <span>{unit.userDetails.firstName} {unit.userDetails.lastName}</span>
                                                            <span style={{ display: 'flex', fontSize: '12px', justifyContent: 'space-between', alignItems: 'center' }}>{unit.userDetails.patientId}</span>

                                                        </div>
                                                        
                                                        <div className="GORDU-user-contact">
                                                            <span className="GORDU-user-email">{unit.userDetails.email}</span>
                                                        </div>
                                                        <div className="GORDU-user-id">ID: {unit.UserID}</div>
                                                    </div>
                                                    <button
                                                        onClick={() => {
                                                            console.log('Upload button clicked');
                                                            console.log('Patient ID:', unit.userDetails.patientId);
                                                            if (onOpenUploadModal) {
                                                                // Determine pre-filled analysis and sample types based on activation ID prefix
                                                                const activationId = unit.ActivationID || '';
                                                                const prefix = activationId.substring(0, 2).toUpperCase();

                                                                let prefilledData = null;

                                                                if (['SP', 'CS', 'NS', 'CG'].includes(prefix)) {
                                                                    prefilledData = {
                                                                        analysisType: 'Whole Genome Sequencing',
                                                                        sampleType: 'Whole Blood'
                                                                    };
                                                                } else if (prefix === 'GH') {
                                                                    prefilledData = {
                                                                        analysisType: 'Metagenome',
                                                                        sampleType: 'Stool'
                                                                    };
                                                                } else if (prefix === 'OH') {
                                                                    prefilledData = {
                                                                        analysisType: 'Metagenome',
                                                                        sampleType: 'Saliva'
                                                                    };
                                                                }

                                                                onOpenUploadModal({
                                                                    patientId: unit.userDetails.patientId,
                                                                    activationId: unit.ActivationID,
                                                                    patientName: unit.userDetails.firstName && unit.userDetails.lastName
                                                                        ? `${unit.userDetails.firstName} ${unit.userDetails.lastName}`
                                                                        : null,
                                                                    patientEmail: unit.userDetails.email || null,
                                                                    prefilledData,
                                                                    kitTypeInfo: unit.kitTypeInfo || null
                                                                });
                                                            }
                                                        }}
                                                        style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#1e4d9898' }}
                                                    >
                                                        <i className="fas fa-upload"></i>
                                                    </button>
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <span className="GORDU-detail-label">User Profile:</span>
                                                <span className="GORDU-detail-value">
                                                    {unit.UserID || 'Not Activated'}
                                                </span>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Actions */}
                            <div className="GORDU-detail-section">
                                <h3>Actions</h3>
                                <div className="GORDU-settings-grid">
                                    {actionOptions.map((action) => {
                                        const isActive = action.key === 'printed' ? isPrinted : false;
                                        return (
                                            <div
                                                key={action.key}
                                                className={`GORDU-settings-tile ${!action.enabled ? 'disabled' : ''} ${isActive ? 'active' : ''}`}
                                                onClick={action.enabled && action.key === 'printed' ? handlePrintToggle : undefined}
                                            >
                                                <div className="GORDU-settings-tile-icon">
                                                    {isMarking && action.key === 'printed' ? (
                                                        <i className="fas fa-spinner fa-spin"></i>
                                                    ) : (
                                                        <i className={action.icon}></i>
                                                    )}
                                                </div>
                                                <div className="GORDU-settings-tile-content">
                                                    <span className="GORDU-settings-tile-label">{action.label}</span>
                                                </div>
                                                {action.key === 'printed' && (
                                                    <div className={`GORDU-settings-toggle ${isPrinted ? 'on' : ''}`}>
                                                        <div className="GORDU-toggle-track">
                                                            <div className="GORDU-toggle-thumb"></div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Timeline */}
                        <div className="GORDU-modal-right-panel">
                            <div className="GORDU-detail-section">
                                <h3>Timeline</h3>
                                <div className="GORDU-timeline">
                                    {timelineStages.map((stage, index) => {
                                        const date = unit[stage.key];
                                        const isCompleted = !!date;
                                        const isLast = index === timelineStages.length - 1;
                                        
                                        return (
                                            <div key={stage.key} className={`GORDU-timeline-item ${isCompleted ? 'completed' : ''}`}>
                                                <div className="GORDU-timeline-connector">
                                                    <div className={`GORDU-timeline-dot ${isCompleted ? 'active' : ''}`}>
                                                        <i className={stage.icon}></i>
                                                    </div>
                                                    {!isLast && <div className={`GORDU-timeline-line ${isCompleted ? 'active' : ''}`}></div>}
                                                </div>
                                                <div className="GORDU-timeline-content">
                                                    <h4>{stage.label}</h4>
                                                    <p>{formatDate(date)}</p>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="GORDU-modal-footer">
                    <button className="GORDU-btn GORDU-btn-secondary" onClick={onClose}>
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
};

export default OrderDetailModal;